import {Component} from 'react'

import Cookies from 'js-cookie'
import Slider from 'react-slick'
import {FaYoutube, FaInstagram, FaGoogle, FaTwitter} from 'react-icons/fa'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import ThemeContext from '../../Context/ThemeContext'

import {Container, SlideContainer} from './StyledComponents'
import Navbar from '../Navbar'

import './index.css'

class Home extends Component {
  state = {topRatedBooks: []}

  componentDidMount() {
    this.getTopRatedBooks()
  }

  getTopRatedBooks = async () => {
    const jwtToken = Cookies.get('jwt_token')
    const options = {
      method: 'GET',
      headers: {Authorization: `Bearer ${jwtToken}`},
    }
    const url = 'https://apis.ccbp.in/book-hub/top-rated-books'
    const response = await fetch(url, options)
    const data = await response.json()
    const {books} = data
    const convertedBooks = books.map(each => this.convertToCamelCase(each))
    this.setState({topRatedBooks: convertedBooks})
  }

  convertToCamelCase = book => ({
    id: book.id,
    title: book.title,
    authorName: book.author_name,
    coverPic: book.cover_pic,
  })

  displaySlides = each => (
    <div>
      <img src={each.coverPic} alt="cover pic" />
    </div>
  )

  onClickFindBooks = () => {
    const {history} = this.props
    history.push('/shelf')
  }

  render() {
    const {topRatedBooks} = this.state
    const settings1 = {
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
    }
    const settings2 = {
      dots: false,
      slidesToShow: 2,
      slidesToScroll: 1,
    }
    return (
      <div>
        <Navbar />
        <ThemeContext.Consumer>
          {value => {
            const {theme} = value
            return (
              <Container isDark={theme} className="home-bg-container">
                <div>
                  <h1 className="home-heading">
                    Find Your Next Favorite Books?
                  </h1>
                  <p className="home-para">
                    You are in the right place. Tell us what titles or genres
                    you have enjoyed in the past, and we will give you
                    surprisingly insightful recommendations.
                  </p>
                  <button
                    onClick={this.onClickFindBooks}
                    type="button"
                    className="find-books-btn1"
                  >
                    Find Books
                  </button>
                  <SlideContainer isDark={theme} className="home-books-slider">
                    <div className="slider-top-container">
                      <h1 className="top-rated-books-heading">
                        Top Rated Books
                      </h1>
                      <button
                        onClick={this.onClickFindBooks}
                        type="button"
                        className="find-books-btn2"
                      >
                        Find Books
                      </button>
                    </div>
                    <Slider {...settings1} className="slider1">
                      {topRatedBooks.map(each => (
                        <div className="slide-container">
                          <img
                            src={each.coverPic}
                            alt="cover pic"
                            className="slide-image"
                          />
                          <h1 className="slide-heading">{each.title}</h1>
                          <p className="slide-para">{each.authorName}</p>
                        </div>
                      ))}
                    </Slider>
                    <Slider {...settings2} className="slider2">
                      {topRatedBooks.map(each => (
                        <div className="slide-container">
                          <img
                            src={each.coverPic}
                            alt="cover pic"
                            className="slide-image"
                          />
                          <h1 className="slide-heading">{each.title}</h1>
                          <p className="slide-para">{each.authorName}</p>
                        </div>
                      ))}
                    </Slider>
                  </SlideContainer>
                </div>
                <div className="contact-container">
                  <div className="contact-logo-container">
                    <FaGoogle
                      color="#717B7B"
                      size={24}
                      className="contact-logo"
                    />
                    <FaTwitter
                      color="#717B7B"
                      size={28}
                      className="contact-logo"
                    />
                    <FaInstagram
                      color="#717B7B"
                      size={26}
                      className="contact-logo"
                    />
                    <FaYoutube
                      color="#717B7B"
                      size={30}
                      className="contact-logo"
                    />
                  </div>
                  <p className="contact-para">Contact Us</p>
                </div>
              </Container>
            )
          }}
        </ThemeContext.Consumer>
      </div>
    )
  }
}
export default Home
